import { RootState } from '../index';
import { StoreStatus, KeyValues } from '../../core/types/common.types';

export const isBusySelector = (state: RootState): boolean =>
  state.summary.status && state.summary.status === StoreStatus.BUSY;

export const hasErrorSelector = (state: RootState): boolean =>
  state.summary.errors && state.summary.errors.length > 0 ? true : false;

export const hasSuccessSelector = (state: RootState): boolean => (state.summary.result ? true : false);

export const resultSelector = (state: RootState): any => state.summary.result;

export const formValueSelector = (state: RootState): KeyValues => state.summary.values || {};
